import React from 'react'
import { Layout } from "../../common"
import { 
    GetYourNFTSection, 
    WelcomeToHashrateSection, 
    JoinCommunitySection,
    CommunityFeaturesSection, 
    ProjectsSection,
    RoadmapSection,
    WhoWeAreSection} from '../../home'

const Home = ({ isSignedIn, connectAction }) => {

    return (
        <Layout isSignedIn={isSignedIn} connectAction={connectAction}>
            <WelcomeToHashrateSection />
            <GetYourNFTSection />
            <JoinCommunitySection />
            <CommunityFeaturesSection />
            <RoadmapSection />
            <WhoWeAreSection />
        </Layout>
    )
}

export default Home